import { render, staticRenderFns } from "./RecentFileView.vue?vue&type=template&id=c7717b6e&scoped=true"
import script from "./RecentFileView.vue?vue&type=script&lang=js"
export * from "./RecentFileView.vue?vue&type=script&lang=js"
import style0 from "./RecentFileView.vue?vue&type=style&index=0&id=c7717b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7717b6e",
  null
  
)

export default component.exports